import { Typography } from '@material-ui/core'
import React from 'react'

export const Letidview = ({ procedureData }: { procedureData: any }) => {
    return (
        <div>
            <Typography variant="body1">
                Test duration :{procedureData?.letid_test?.test_duration ?`${procedureData.letid_test.test_duration} hours`  : "N/A"} 
            </Typography>
            <Typography variant="body1">
                Test temperature : {procedureData?.letid_test?.test_temperature ?`${procedureData.letid_test.test_temperature} °C`  : "N/A"} 
            </Typography>
            <Typography variant="body1">
                Current is normal :{procedureData?.letid_test?.current_normal ? procedureData.letid_test.current_normal: "N/A"}
            </Typography>
            <Typography variant="body1">
                Calibration Date :{procedureData?.letid_test?.equipment_calibration_date ? procedureData.letid_test.equipment_calibration_date.substring(0, 10)  : "N/A"}
            </Typography>
        </div>
    )
}


